import React from "react";
import classNames from "classnames";
import { Button } from "@/components/Button";
import { checkValidURL } from "@/utils/formHelper";
import { isClient } from "@/utils/browser";
import "./PreviewPrimaryAction.scss";

export interface PreviewPrimaryActionProps {
  /** Texto del botón */
  text?: string;
  /** URL de destino */
  url?: string;
  /** Color del tema del botón */
  buttonColor?: string;
  /** Variante de estilo */
  variant?: "primary" | "secondary" | "outline";
  /** Clase CSS adicional */
  className?: string;
  /** Propiedades adicionales del botón */
  [key: string]: any;
}

/**
 * Componente CTA unificado para previews de QR
 * Maneja navegación Link y validación de URLs automáticamente
 */
export function PreviewPrimaryAction({
  text,
  url,
  buttonColor,
  variant = "primary",
  className,
  ...rest
}: PreviewPrimaryActionProps) {
  if (!text) {
    return null;
  }

  const handleClick = () => {
    if (url && isClient()) {
      const validUrl = checkValidURL(url);
      if (validUrl) {
        window.open(validUrl, "_blank");
      }
    }
  };

  const buttonClasses = classNames(
    "preview-primary-action",
    {
      "preview-primary-action--secondary": variant === "secondary",
      "preview-primary-action--outline": variant === "outline",
    },
    className
  );

  return (
    <Button
      label={text}
      buttonColor={buttonColor}
      customClass={buttonClasses}
      onClick={handleClick}
      {...rest}
    />
  );
}
